import {createFeatureSelector, createSelector} from '@ngrx/store';
import {StoreKeys} from '../../models/store-keys';
import { ViewState } from './reducer/view.reducer';


export const selectViewFeature = createFeatureSelector<ViewState>(StoreKeys.VIEW);

export const selectViewDatas = createSelector(selectViewFeature, state => state.datas);
